import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import SignIn from "./pages/Login";
import AddItem from "./pages/AddItem";
import Category from "./pages/Category";
import Item from "./pages/Item";
import EditItem from "./pages/EditItem";

function App() {
  return (
    <Router>
      <NavigationBar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/additem" element={<AddItem />} />
        <Route exact path="/login" element={<SignIn />} />
        <Route exact path="/category/:category" element={<Category />} />
        <Route exact path="/item/:id" element={<Item />} />
        <Route path="/edititem/:id" element={<EditItem />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
